import {RootState} from '../../store';
import {Order} from './types';

export const selectionSelector = (state: RootState): Record<string, Order> =>
    state['orders'].selection as Record<string, Order>;
